import type { ImpactReportApi, ImpactReportView } from 'v2/interfaces/impactMeter';

export function adaptImpactReport(report: ImpactReportApi | null): ImpactReportView | null {
  if (!report?.updatedAt) {
    return null;
  }

  return {
    estimatedImpactCount: report.estimatedImpactCount ?? 0,
    impactedLivesCount: report.impactedLivesCount ?? 0,
    impactfulProductsCount: report.impactfulProductsCount ?? 0,
    impactedLivesLast30Days: report.impactedLivesLast30Days ?? 0,
    yearsAtEduzz: report.yearsAtEduzz ?? 0,
    monthsAtEduzz: report.monthsAtEduzz ?? 0,
    daysAtEduzz: report.daysAtEduzz ?? 0,
    updatedAt: report.updatedAt,
    customerName: report.customerName?.trim() ?? '',
    customerId: report.customerId || null
  };
}
